import * as React from 'react';
import { LeafletContext, LeafletTooltipContext } from './Leaflet.context';

const hookContextFactory = function <T>(context: React.Context<T>) {
  return () => {
    const contextDispatcher = React.useContext<T>(context)!;
    return (contextDispatcher || [null, () => { }]) as typeof contextDispatcher;
  }
}

export const useLeafletMap = hookContextFactory(LeafletContext);
export const useLeafletTooltip = hookContextFactory(LeafletTooltipContext);